import { axiosPlatform } from "../../../_services/axios-helper";

export const lexofficeService = {
    getStripeLexOfficeConfigurations,
    updateStripeLexOfficeConfiguration,
    deleteStripeLexOfficeConfiguration,
    getLexOfficeConnectionStatus,
    getLexOfficeLog,
    registerOrganization,
    refreshLexOfficeToken,
};

function getStripeLexOfficeConfigurations() {
    return axiosPlatform().get("/integrations/lexoffice/stripe");
}

function updateStripeLexOfficeConfiguration(configuration) {
    return axiosPlatform().post("/integrations/lexoffice/stripe", configuration);
}

function deleteStripeLexOfficeConfiguration(configurationId, doCleanup) {
    return axiosPlatform().delete("/integrations/lexoffice/stripe/" + configurationId + "?cleanup=" + doCleanup);
}

function getLexOfficeConnectionStatus() {
    return axiosPlatform().get("/integrations/lexoffice/status");
}

function getLexOfficeLog(amount, page, start, end) {
    let params = "";
    if (amount) {
        params += "amount=" + amount + "&";
    }

    if (page) {
        params += "page=" + page + "&";
    }

    if (start) {
        params += "start=" + start + "&";
    }

    if (end) {
        params += "end=" + end + "&";
    }

    return axiosPlatform().get("/integrations/lexoffice/log" + (params !== "" ? "?" + params : ""));
}

function registerOrganization(request) {
    return axiosPlatform().post("/oauth/lexoffice/register", request);
}

function refreshLexOfficeToken() {
    return axiosPlatform().get("/integrations/lexoffice/tokenrefresh");
}
